import React from 'react';
import { Play, Sparkles as Sp2 } from 'lucide-react';
import { college, heroImage } from '../../mock/data';

export default function HeroVisual() {
  return (
    <div className="relative">
      <div className="relative rounded-[28px] overflow-hidden shadow-[0_30px_60px_-25px_rgba(11,46,110,0.35)] ring-1 ring-white/60">
        <img
          src={heroImage}
          alt="Pharmacy students in modern laboratory"
          className="w-full h-[440px] md:h-[520px] object-cover"
          loading="eager"
        />
        <button
          type="button"
          aria-label="Play video"
          className="absolute inset-0 m-auto w-16 h-16 rounded-full bg-white/90 hover:bg-white shadow-xl flex items-center justify-center transition-transform hover:scale-105"
        >
          <Play className="text-[#0B2E6E] ml-1" />
        </button>
      </div>

      <div className="glass floating-tag absolute -top-4 left-4 md:left-8 rounded-2xl px-4 py-3 flex items-center gap-3">
        <img src={college.logo} alt="logo" className="h-10 w-10 rounded-full object-cover" />
        <div>
          <div className="text-[11px] text-slate-500 font-semibold uppercase tracking-wider">PCI Approved</div>
          <div className="font-bold text-[#0B2E6E] leading-tight">100% Recognized</div>
        </div>
      </div>

      <div className="glass floating-tag absolute -bottom-5 right-4 md:right-8 rounded-2xl px-4 py-3 flex items-center gap-3" style={{ animationDelay: '1s' }}>
        <div className="w-10 h-10 rounded-xl bg-[var(--pca-blue-soft)] flex items-center justify-center">
          <Sp2 className="text-[var(--pca-blue)]" size={20} />
        </div>
        <div>
          <div className="text-[11px] text-slate-500 font-semibold uppercase tracking-wider">Placement</div>
          <div className="font-bold text-[#0B2E6E] leading-tight">92% Placed</div>
        </div>
      </div>
    </div>
  );
}
